import './page_result.styl';

import React from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { route } from '@ali/react-router-lite';
import getLocale from '@ali/brokkoli/lib/utils/get_locale';
import Header from '@ali/broccoli-cmp-header';
import log from '@ali/log';
import { getMatchValueArray } from '../utils';
// import getLocale from '@ali/brokkoli/lib/utils/get_locale';
const { SHARE_TYPE: { FB, JSSDK, CLIENT }, share } = require('@ali/bucket/components/share');

const pg = 'result';

class PageResult extends React.Component {
  constructor(props) {
    super(props);
    const { questionOrder } = this.props;
    const allAnswer = this.getAllAnswer();
    this.correctAnswer = questionOrder.map(item => allAnswer[item]);
    this.degreeColor = this.props.degreeColor;
    this.descColor = this.props.resultDescColor;
    this.replayColor = this.props.replayColor;
    this.shareBackground1 = `${this.props.imgCdnPrefix}share-fb.png`;
    this.shareBackground2 = `${this.props.imgCdnPrefix}share-wa.png`;
    this.allBackgroundUrl = this.getAllBackgroundUrl();
    this.allDescription = this.getAllDesction();
  }

  componentWillMount() {
    console.log(this.getAllBackgroundUrl());
  }

  componentDidMount() {
    log.logVisit(pg);
  }

  getAllAnswer() {
    const macher = /question_right_answer/;
    const object = getLocale('page_qna');
    return getMatchValueArray(object, macher);
  }

  getAllBackgroundUrl() {
    const pageResult = getLocale('page_result');
    const matcher = /match_value_bg/;
    return getMatchValueArray(pageResult, matcher);
  }
  getCurrentBackgroundUrl() {
    if (Array.isArray(this.getAllBackgroundUrl())) {
      const index = this.getResultIndex();
      return this.allBackgroundUrl[index];
    }
    return '';
  }
  getAllDesction() {
    const pageResult = getLocale('page_result');
    const matcher = /match_value_text/;
    return getMatchValueArray(pageResult, matcher);
  }
  getCurrentDesction() {
    if (Array.isArray(this.getAllDesction())) {
      const index = this.getResultIndex();
      return this.allDescription[index];
    }
    return '';
  }
  getResultIndex() {
    const questionsLength = this.props.questionOrder.length;
    // const index = this.getScore() === 0 ? 0 : this.getScore() / (100 / questionsLength) - 1;
    let index = 0;
    switch (this.getScore()) {
      case 0:
        index = 0;
        break;
      case 100:
        index = questionsLength - 1;
        break;
      default:
        index = Math.floor(this.getScore() / Math.floor(100 / questionsLength));
        break;
    }
    return index;
  }
  getScore() {
    const { answer: userAnswer, questionOrder } = this.props;
    const questionAmount = questionOrder.length;
    let correctAnswers = 0;
    let result = 0;
    userAnswer.forEach((answer, index) => {
      if (`${answer}` === this.correctAnswer[index]) {
        correctAnswers++;
      }
    });
    if (questionAmount === correctAnswers) {
      result = 100;
    } else {
      result = Math.floor(100 / questionAmount * correctAnswers);
    }
    return result;
  }
  getScoreBackgroundUrl() {
    return getLocale('page_result.match_value_img1');
  }
  handleClickReplay = () => {
    route.goHash('answer');
  }
  handleClickFacebookShare = () => {
    const shareResult = getLocale('share_result');
    const score = this.getScore();
    const shareConfig = {
      scene: 'share_result',
      shareBackupList: [ FB, CLIENT ],
      logParams: {
        ckId: `shareckid_fb${this.getScore()}`,
        pg,
      },
      query: {
        link: {
          __tspec: shareResult.title.replace(/\{.+\}/, score).replace(/\s/g, '\t'),
        },
      },
      isShortLink: true
    };
    share(shareConfig);
  }

  handleClickWhatsappShare = () => {
    const shareResult = getLocale('share_result');
    const score = this.getScore();
    const shareConfig = {
      scene: 'share_result',
      shareBackupList: [ JSSDK, CLIENT ],
      logParams: {
        ckId: `shareckid_wa${this.getScore()}`,
        pg,
      },
      query: {
        link: {
          __tspec: shareResult.title.replace(/\{.+\}/, score).replace(/\s/g, '\t'),
        },
      },
      isShortLink: true
    };
    share(shareConfig);
  }

  renderReplaySvg() {
    const fillColor = this.replayColor;
    return (
      <svg width="22" height="22">
        <g fill={fillColor}>
          <g>
            <path d="M11,21.3c-0.1,0-0.2,0-0.2,0c-2.2-0.1-4.3-1-5.9-2.6s-2.3-3.8-2.3-6c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5
              c0,1.4,0.5,2.8,1.5,3.8c1,1,2.3,1.6,3.8,1.7c1.4,0,2.8-0.5,3.8-1.5s1.6-2.3,1.7-3.8c0.1-3-2.3-5.4-5.2-5.5c-0.8,0-1.5-0.7-1.5-1.5
              c0-0.8,0.7-1.5,1.5-1.5c4.6,0.1,8.3,4,8.1,8.6c-0.1,2.2-1,4.3-2.6,5.9C15.2,20.5,13.2,21.3,11,21.3z"/>
          </g>
          <g>
            <polygon points="2.8,5.9 11.8,0.7 11.8,11.2 		"/>
          </g>
        </g>
      </svg>
    );
  }
  render() {
    const { imgCdnPrefix, linkRule } = this.props;
    const changeLanguageIcon = `${imgCdnPrefix}lange-icon.png`;
    const shareBtnIcon = `${imgCdnPrefix}share-icon.png`;
    const ruleBtnIcon = `${imgCdnPrefix}rule-icon.png`;
    return (
      <div
        className="page-result"
        style={{ backgroundImage: `url(${this.getCurrentBackgroundUrl()})` }}>
        <Header
          pg={`shareckid_end${this.getScore()}`}
          shareScene={'share_page'}
          linkRule={linkRule}
          shareBtnStyle={{
            background: `url(${shareBtnIcon})`,
            backgroundRepeat: 'no-repeat',
          }}
          ruleBtnStyle={{
            background: `url(${ruleBtnIcon})`,
            backgroundRepeat: 'no-repeat',
          }}
          // TODO: 需要迭代change-lange组件，改颜色配置项为String类型
          langeConf={{
            bgColor: '#032048',
            selectBgColor: '#0159ce',
            tabListKey: 'lange_switch.lange',
            btnBgImg: changeLanguageIcon,
            left: 82,
            top: 22,
            btnStyle: { width: '.051rem', height: '.051rem' },
            listStyle: { top: '0.06rem', left: '20%', width: '0.1rem' },
          }}/>
        <div className="content-container">
          <div className="header"></div>
          {/* <div className="score-container" style={{
            backgroundImage: `url(${this.getScoreBackgroundUrl()})`,
            color: this.degreeColor,
          }}>
            <span className="score-word">{getLocale('your scrore:')}</span><span className="score">{this.getScore()}</span>
          </div> */}
          <div
            className="desc"
            dangerouslySetInnerHTML={{ __html: this.getCurrentDesction() }}
            style={{ color: this.descColor }}
          ></div>
          <div className="share-container">
            <span
              style={{ backgroundImage: `url(${this.shareBackground1})` }}
              className="share1"
              onClick={this.handleClickFacebookShare}
              />
            <span
              style={{ backgroundImage: `url(${this.shareBackground2})` }}
              className="share2"
              onClick={this.handleClickWhatsappShare}
              />
          </div>
          <div className="again" onClick={this.handleClickReplay}>
            {this.renderReplaySvg()}<span className="try-again" style={{ color: this.replayColor }}>{getLocale('try again')}</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const conf = state.init.conf.pageResult;
  const commonConfig = state.init.conf.commonConfig;
  const index = state.index;
  const {
    degreeColor,
    resultDescColor,
    replayColor,
  } = conf;
  const {
    imgCdnPrefix,
    rule,
  } = commonConfig;
  const {
    answer,
    questionOrder,
  } = index;
  return {
    degreeColor,
    resultDescColor,
    replayColor,
    imgCdnPrefix,
    answer,
    questionOrder,
    linkRule: rule,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(PageResult);
